globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.BookingHourPeriodsController = (function(superClass) {

  utils.extend(BookingHourPeriodsController, superClass);

  function BookingHourPeriodsController() {
    return BookingHourPeriodsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(BookingHourPeriodsController.prototype, {
    init: function(){
      this.initEvents();

      return BookingHourPeriodsController.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      var $form = $('form.regular-hours-form');

      $form.on('change', '.open-state .switchery', function(){
        var $checkbox = $(this),
            $formGroup = $checkbox.closest('.form-group'),
            $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
            $slotHourItem = $regularHoursWrapper.find('.slot-hour-item'),
            $openLabel = $formGroup.find('.open-label'),
            $closeLabel = $formGroup.find('.close-label'),
            $dayLabel = $formGroup.find('.day-label'),
            $inputOpenTime = $slotHourItem.find('input.input-open-time'),
            $inputCloseTime = $slotHourItem.find('input.input-close-time'),
            $inputOpenTimeWrapper = $inputOpenTime.closest('.input-open-time-wrapper'),
            $inputCloseTimeWrapper = $inputCloseTime.closest('.input-close-time-wrapper');

        if($checkbox.is(':checked')) {
          $openLabel.show();
          $closeLabel.hide();
          $dayLabel.removeClass('text-muted');
          $regularHoursWrapper.show();
          $slotHourItem.find('input.input-destroy').val(false).end().show();

          var dayIndex = parseInt($checkbox.closest('.hours-on-day').data("day-index")),
              $previousDayHoursContent = $form.find('#hours-on-day-' + (dayIndex - 1)),
              $previousOpenState = $previousDayHoursContent.find('.open-state .switchery'),
              previousOpenTimeHoursValue = $previousDayHoursContent.find('.open-time-hours').val(),
              previousOpenTimeMinutesValue = $previousDayHoursContent.find('.open-time-minutes').val(),
              previousCloseTimeHoursValue = $previousDayHoursContent.find('.close-time-hours').val(),
              previousCloseTimeMinutesValue = $previousDayHoursContent.find('.close-time-minutes').val();

          if (previousOpenTimeHoursValue && previousOpenTimeHoursValue.length == 1) {
            previousOpenTimeHoursValue = '0' + previousOpenTimeHoursValue;
          }
          if (previousOpenTimeMinutesValue && previousOpenTimeMinutesValue.length == 1) {
            previousOpenTimeMinutesValue = '0' + previousOpenTimeMinutesValue;
          }
          if (previousCloseTimeHoursValue && previousCloseTimeHoursValue.length == 1) {
            previousCloseTimeHoursValue = '0' + previousCloseTimeHoursValue;
          }
          if (previousCloseTimeMinutesValue && previousCloseTimeMinutesValue.length == 1) {
            previousCloseTimeMinutesValue = '0' + previousCloseTimeMinutesValue;
          }
          if ($previousOpenState.is(':checked') && previousOpenTimeHoursValue != "00") {
            if ($inputOpenTime.val() == "00:00") {
              $inputOpenTimeWrapper.find('.open-time-hours').val(previousOpenTimeHoursValue);
              $inputOpenTimeWrapper.find('.open-time-minutes').val(previousOpenTimeMinutesValue);
              $inputOpenTime.val(previousOpenTimeHoursValue + ':' + previousOpenTimeMinutesValue);
            }
            if ($inputCloseTime.val() == "00:00") {
              $inputCloseTimeWrapper.find('.close-time-hours').val(previousCloseTimeHoursValue);
              $inputCloseTimeWrapper.find('.close-time-minutes').val(previousCloseTimeMinutesValue);
              $inputCloseTime.val(previousCloseTimeHoursValue + ':' + previousCloseTimeMinutesValue);
            }
          } else {
            if ($inputOpenTime.val() == "00:00") {
              $inputOpenTimeWrapper.find('.open-time-hours').val("09");
              $inputOpenTimeWrapper.find('.open-time-minutes').val("00");
              $inputOpenTime.val("09:00");
            }
            if ($inputCloseTime.val() == "00:00") {
              $inputCloseTimeWrapper.find('.close-time-hours').val("18");
              $inputCloseTimeWrapper.find('.close-time-minutes').val("00");
              $inputCloseTime.val("18:00");
            }
          }
        } else {
          $openLabel.hide();
          $closeLabel.show();
          $dayLabel.addClass('text-muted');
          $regularHoursWrapper.find('input.input-destroy').val(true).end().hide();
        }
      });

      $form.on('input', '.input-open-time', function(){
        var $inputOpenTime = $(this),
            $inputOpenTimeWrapper = $inputOpenTime.closest('.input-open-time-wrapper'),
            $openTimeHours = $inputOpenTimeWrapper.find('.open-time-hours'),
            $openTimeMinutes = $inputOpenTimeWrapper.find('.open-time-minutes'),
            openTimeValue = $inputOpenTime.val().split(":");

        $openTimeHours.val(parseInt(openTimeValue[0]));
        $openTimeMinutes.val(parseInt(openTimeValue[1]));
      });

      $form.on('input', '.input-close-time', function(){
        var $inputCloseTime = $(this),
            $inputCloseTimeWrapper = $inputCloseTime.closest('.input-close-time-wrapper'),
            $closeTimeHours = $inputCloseTimeWrapper.find('.close-time-hours'),
            $closeTimeMinutes = $inputCloseTimeWrapper.find('.close-time-minutes'),
            closeTimeValue = $inputCloseTime.val().split(":");

        $closeTimeHours.val(parseInt(closeTimeValue[0]));
        $closeTimeMinutes.val(parseInt(closeTimeValue[1]));
      });

      $form.on('click', '.day-delete-hour', function(event){
        event.preventDefault();
        var $deleteButton = $(this),
            $regularHourItem = $deleteButton.closest('.slot-hour-item'),
            $formGroup = $deleteButton.closest('.form-group'),
            $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
            $checkbox = $formGroup.find('input[type=checkbox]'),
            $openLabel = $formGroup.find('.open-label'),
            $closeLabel = $formGroup.find('.close-label'),
            isHidden = true;

        $regularHourItem.find('input.input-destroy').val(true).end().hide();

        $regularHoursWrapper.find('.slot-hour-item').each(function(){
          if (!$(this).is(':hidden')) {
            isHidden = false;
          }
        });
        if (isHidden) {
          $openLabel.hide();
          $closeLabel.show();
          $checkbox.click();
        }
      });

      $form.on('click', '.day-add-regular-hour', function(event){
        event.preventDefault();
        var $dayAddRegularHour = $(this),
            $formGroup = $dayAddRegularHour.closest('.form-group'),
            $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
            url = $dayAddRegularHour.data("url");

        $.ajax({
          type: "POST",
          url: url,
          success: function(data)
          {
            if (data.response == 1) {
              if (data.views !== undefined && data.views.regularHourThumbnail !== undefined) {
                $regularHoursWrapper.append($(data.views.regularHourThumbnail));
                $regularHoursWrapper.find('.slot-hour-item').find('input.input-destroy').val(false);
              }
            } else {
              $.each(data.errors, function(key, value) {
                var $error = $('<p class="error">' + value[0] + '</p>');
                $error.prependTo($dayAddRegularHour);
              });
            }
          }
        });
      });
    }
  });

  return BookingHourPeriodsController;

})(appCustomerSpace.Controllers.Settings.MainController);
